import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 60);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16 md:h-18">
        <Link to="/" className="flex items-center gap-2 group cursor-pointer">
          <span className={`font-heading text-2xl md:text-3xl font-bold tracking-tight transition-colors duration-300 ${
            scrolled ? 'text-foreground-950' : 'text-background-50'
          }`}>
            The<span className="italic font-normal">Vertex</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {categories.slice(0, 4).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                scrolled
                  ? 'text-foreground-700 hover:text-primary-600'
                  : 'text-background-50/80 hover:text-background-50'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
              scrolled
                ? 'text-foreground-700 hover:text-primary-600'
                : 'text-background-50/80 hover:text-background-50'
            }`}
          >
            About
          </Link>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button
            className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors duration-200 cursor-pointer ${
              scrolled
                ? 'text-foreground-600 hover:text-foreground-950 hover:bg-background-200'
                : 'text-background-50/70 hover:text-background-50 hover:bg-background-50/10'
            }`}
            aria-label="Search"
          >
            <i className="ri-search-line text-lg"></i>
          </button>
        </div>

        <button
          className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
            scrolled ? 'text-foreground-800' : 'text-background-50'
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="text-foreground-700 hover:text-primary-600 text-sm font-medium py-1.5 transition-colors cursor-pointer"
                onClick={() => setMobileOpen(false)}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="text-foreground-700 hover:text-primary-600 text-sm font-medium py-1.5 transition-colors cursor-pointer"
              onClick={() => setMobileOpen(false)}
            >
              About
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}